import { UserSessionResponse } from '../../api-models';
import { User } from '../../types/core.type';
import Role, { HTTPMethod } from '../../types/enums';
import { AdapterInterface } from '../../types/global';
import BaseAdapter from './baseAdapter';

export default class UserAdapter extends BaseAdapter<UserSessionResponse> implements AdapterInterface {
  rawResponse: UserSessionResponse;

  async adaptResponse(): Promise<User | null> {
    await this.fetchApiResponse('/api/session/user', HTTPMethod.Get);
    if (!this.rawResponse) { return null; }
    return {
      firstName: this.rawResponse.first_name,
      lastName: this.rawResponse.last_name,
      email: this.rawResponse.email,
      organisationDisplayName: this.rawResponse.organisation_display_name,
      role: Role[this.rawResponse.role_name as keyof typeof Role],
      hmrcDataToggle: {
        isDisplayed: this.rawResponse.hmrc_data_toggle.is_displayed,
        isEnabled: this.rawResponse.hmrc_data_toggle.is_enabled,
        branch: this.rawResponse.hmrc_data_toggle.branch,
        expiresAt: this.rawResponse.hmrc_data_toggle.expires_at,
      },
    };
  }
}
